import React from 'react';

const HumanTime = ({ isoDate, includeTime = false }) => {

    if (!isoDate)
        return;

    const date = new Date(isoDate);

    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };


    if (includeTime) {
        options.hour= '2-digit'
        options.minute= '2-digit'
        options.second= '2-digit'
        options.timeZone= 'Asia/Colombo'
    }

    // Convert to "Month Date, Year" format in the specified timezone
    const humanReadableDate = date.toLocaleString('en-US', options);

    return humanReadableDate;
};

export default HumanTime;
